import { mapperModuleMediaCard, mapperModuleNavigationLink } from '#layers/core/data-layer/modules/mappers'
import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page contact detail mapper
 * normalizes data to be used in pages
 * @param {Object} data - cms data
 * @return {Object} - normalized page data
 */
export const mapperPageContactDetail = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const getInternalUrl = options.getInternalUrl
  const getUrl = options.getUrl

  if (!getInternalUrl || !getUrl) {
    return null
  }

  return {
    icon: mapperIcon(data.icon),
    description: data.description || '',
    link: mapperModuleNavigationLink(data.informationLink, getUrl),
    formTitle: data.formTitle || '',
    formId: data.formId || null,
    formMessageFieldLabel: data.formMessageFieldLabel || '',
    formThankYouPageLink: getInternalUrl(data.formThankYouPage?.sys?.id) || '',
    pointsOfContactItems:
      data.pointsOfContactCollection?.items.map((item: any) => mapperModuleMediaCard(item, options)) || []
  }
}
